import {createContext, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import { io } from "socket.io-client";
import {
	apiError,
	handleRequest,
	checkAuthorization
} from "~/utils";
import {
	groupApi,
	utilitiesApi,
} from "~/api";
import {Loading} from "../components";
import {useViewport} from "~/hooks";
import {authActions} from "~/features/Auth/authSlice";
import authApi from "../api/authApi";
import {
	getAllProvinces,
	isLocationCached,
	saveProvinces,
	saveWards
} from "../utils/db";

const AppContext = createContext(undefined);

// APP GLOBAL DATA
function AppProvider({ children }) {

	const dispatch = useDispatch();

	const [loading, setLoading] = useState(true);

	const [onlineUsers, setOnlineUsers] = useState([]);

	const [loginAsUsers, setLoginAsUsers] = useState([]);

	const [notificationCount, setNotificationCount] = useState({
		builderLicense: 0,
		comment: 0,
		notification: 0,
		tasks: 0,
		form: {
			sabbatical: 0,
			salary: 0,
			payment: 0,
			papers:0,
		}
	});

	//Danh sách tỉnh thành quận huyện
	const [country, setCountry] = useState({
		'city' 		: [],
		'district' 	: [],
		'ward' 		: [],
	});

	const [utilities, setUtilities] = useState({
		'key'               : '',
		'roles'             : [],
		'departments' 	    : [],
		'services' 		    : [],
		'serviceTypes'      : [],
		'payTypes' 		    : [],
		'devSource'         : [],
		'reasonStopReNew'   : [],
		'status'   			: [],
	});

	//Danh sách kỹ thuật
	const [listAssign, setListAssign] = useState([]);

	//Danh sách design
	const [listDesign, setListDesign] = useState([]);

	let [groups, setGroups] = useState([]);

	const [socket, setSocket] = useState({});

	const [userLogin, setUserLogin] = useState(false);

	const [tableHeight, setTableHeight] = useState('60vh');

	useEffect(() => {
		const socketConnect = io("ws://"+process.env.REACT_APP_SOCKET_URL+":"+process.env.REACT_APP_SOCKET_PORT, { withCredentials: false, });
		setSocket(socketConnect);
		return () => {
			socketConnect.disconnect();
		}
	}, [])

	useEffect(() => {
		if(checkAuthorization()) {
			(async () => {
				//Kiểm tra login
				let [errorUser, responseUser] = await handleRequest(authApi.current());
				let messageUser = apiError(`Lấy thông tin tài khoản thất bại`, errorUser, responseUser);
				if (!messageUser)
				{
					dispatch(authActions.loginSuccess(responseUser.data));

					/* Các Thông tin khác */
					utilities.key = localStorage.getItem('utilities-key');

					if (responseUser.data.utilities !== utilities.key)
					{
						let [error, response] = await handleRequest(utilitiesApi.gets());

						let message = apiError(`Load thông tin thất bại`, error, response);

						if (!message)
						{
							utilities.roles = response.data.roles;
							utilities.departments = response.data.departments;
							utilities.services = response.data.services;
							utilities.serviceTypes = response.data.serviceTypes;
							utilities.payTypes = response.data.payTypes;
							utilities.devSource = response.data.devSource;
							utilities.reasonStopReNew = response.data.reasonStopReNew;
							utilities.company = response.data.company;
							utilities.status = response.data.status;
							localStorage.setItem('utilities-roles', JSON.stringify(utilities.roles));
							localStorage.setItem('utilities-departments', JSON.stringify(utilities.departments));
							localStorage.setItem('utilities-services', JSON.stringify(utilities.services));
							localStorage.setItem('utilities-serviceTypes', JSON.stringify(utilities.serviceTypes));
							localStorage.setItem('utilities-payTypes', JSON.stringify(utilities.payTypes));
							localStorage.setItem('utilities-devSource', JSON.stringify(utilities.devSource));
							localStorage.setItem('utilities-reasonStopReNew', JSON.stringify(utilities.reasonStopReNew));
							localStorage.setItem('utilities-status', JSON.stringify(utilities.status));
							localStorage.setItem('utilities-company', JSON.stringify(utilities.company));
							localStorage.setItem('utilities-key', response.data.key);
							setUtilities(utilities);
						}
					}
					else
					{
						utilities.roles = JSON.parse(localStorage.getItem('utilities-roles'));
						utilities.departments = JSON.parse(localStorage.getItem('utilities-departments'));
						utilities.services = JSON.parse(localStorage.getItem('utilities-services'));
						utilities.serviceTypes = JSON.parse(localStorage.getItem('utilities-serviceTypes'));
						utilities.payTypes = JSON.parse(localStorage.getItem('utilities-payTypes'));
						utilities.devSource = JSON.parse(localStorage.getItem('utilities-devSource'));
						utilities.reasonStopReNew = JSON.parse(localStorage.getItem('utilities-reasonStopReNew'));
						utilities.status = JSON.parse(localStorage.getItem('utilities-status'));
						utilities.company = JSON.parse(localStorage.getItem('utilities-company'));
						setUtilities(utilities);
						// eslint-disable-next-line react-hooks/exhaustive-deps
						//groups = JSON.parse(localStorage.getItem('groups'));
						//setGroups(groups);
					}

					if(!groups?.length || groups.length === 0)
					{
						/* Danh sách nhóm */
						let [error, response] = await handleRequest(groupApi.all({public: 1}));
						let message = apiError(`Load danh sách nhóm thất bại`, error, response);

						if (!message)
						{
							localStorage.setItem('groups', JSON.stringify(response.data));
							setGroups(response.data);
						}
					}

					/* Số tin nhắn */
					let [error, response] = await handleRequest(utilitiesApi.notification());
					let message = apiError(`Load số message mới thất bại`, error, response);
					if (!message) {
						setNotificationCount((
							prevState) => ({
							...prevState,
							builderLicense: response.data.builderLicense,
							comment: response.data.message,
							notification: response.data.notification,
							tasks: response.data.task,
							form: {
								sabbatical: response.data.formSabbatical,
								salary: response.data.formSalary,
								payment: response.data.formPayment,
								papers: response.data.paper,
							}
						}))
					}
				}

				const loadLocation = async () =>
				{
					const cached = await isLocationCached();

					if (!cached)
					{
						// 1. Lấy danh sách tỉnh
						const resProvinces = await fetch('https://cms.sikido.vn/api/location/v2/provinces/vi');
						const provinces = (await resProvinces.json()).data;
						await saveProvinces(provinces);

						// 3. lấy phường xã
						const resWards = await fetch(`https://cms.sikido.vn/api/location/v2/wards`);
						const wards = (await resWards.json()).data;
						for (const item of wards)
						{
							await saveWards(item?.wards);
						}
					}

					country.city = await getAllProvinces();
					setCountry(country);
				};

				await loadLocation();

				setLoading(false);
			})();
		}
		else
		{
			setLoading(false);
		}
	}, [userLogin]);

	// Handle reponsive
	const viewport = useViewport();
	const [isMobile, setIsMobile] = useState(false);
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		if (viewport.width < 768) {
			setIsMobile(true);
			setIsDesktop(false);
			setTableHeight('50vh');
		} else {
			setIsMobile(false);
			setIsDesktop(true);
			setTableHeight('60vh');
		}
	}, [viewport.width]);

	if (loading) return <Loading />

	return (
		<AppContext.Provider value={{
			country,
			setCountry,
			isMobile,
			isDesktop,
			onlineUsers,
			setOnlineUsers,
			socket,
			setSocket,
			notificationCount,
			setNotificationCount,
			utilities,
			loginAsUsers,
			setLoginAsUsers,
			userLogin,
			setUserLogin,
			setGroups,
			groups,
			listAssign,
			setListAssign,
			listDesign,
			setListDesign,
			tableHeight
		}}>
			{children}
		</AppContext.Provider>
	)
}

export { AppContext };
export default AppProvider;